module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-search-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "搜尋藥物名稱"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), (_vm.showLoader) ? _c('Loader') : _c('div', {
    staticClass: "drug-search-list"
  }, [(_vm.filterDrugInDeviceList.length !== 0) ? _c('div', [_vm._l((_vm.filterDrugInDeviceList), function(drug, num) {
    return (_vm.viewMode === 'drugStorageList') ? _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': drug.selected, 'avoid-clicks': (drug.stock === 0 && _vm.currentApp.name === '一般取藥') || (drug.max_stock === drug.stock && _vm.currentApp.name === '補充藥物')
      },
      on: {
        "click": function($event) {
          return _vm.selectDrug(drug)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head",
      style: ({
        width: _vm.drugItemHeadWidth
      })
    }, [_c('div', {
      staticClass: "drug-head-icon-wrap"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.circleIcon,
        "size": "lg",
        "color": "orange"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.pillBottleIcon,
        "transform": "shrink-6 right-3",
        "color": "white"
      }
    })], 1)], 1), _c('div', {
      staticClass: "drug-head--content"
    }, [_c('span', [_vm._v(_vm._s(drug.medication.CGMH_number) + " - " + _vm._s(drug.medication.code))]), _c('p', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "posistion"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("位置(櫃-層-列-行)")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.device.net.open_times) + " - " + _vm._s(drug.device.net.row_id) + " - " + _vm._s(drug.device.pos_row) + " - " + _vm._s(drug.device.relative_col))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "max-amount"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("庫存量(最大量)")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.stock) + "(" + _vm._s(drug.max_stock) + ")")])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "patch"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("批號")])]), _c('div', {
      staticClass: "info-col-content"
    }, [(drug.patch_number === undefined || drug.patch_number === null || drug.patch_number === '') ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(drug.patch_number))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "expired-date"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("有效期限")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.expired_date))])])])])]) : _vm._e()
  }), _vm._l((_vm.drugStorageByDrug), function(item) {
    return (_vm.viewMode === 'medList') ? _c('div', {
      staticClass: "drug-button btn drug-button-by-med",
      class: {
        'avoid-clicks': (item.stock === 0 && _vm.currentApp.name === '一般取藥'), 'drug-selected': item.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectDrugByMed(item)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head",
      style: ({
        width: _vm.drugItemHeadWidth
      })
    }, [_c('div', {
      staticClass: "drug-head-icon-wrap"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.circleIcon,
        "size": "lg",
        "color": "red"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.pillsIcon,
        "transform": "shrink-6 right-2",
        "color": "white"
      }
    })], 1)], 1), _c('div', {
      staticClass: "drug-head--content"
    }, [_c('span', [_vm._v(_vm._s(item.medication.CGMH_number) + " - " + _vm._s(item.medication.code))]), _c('p', [_vm._v(_vm._s(item.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col"
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("藥倉數量")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('span', [_vm._v(_vm._s(item.lists.length))])])]), (_vm.$store.state.currentApp.name === '補充藥物') ? _c('div', {
      staticClass: "info-col"
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("可補量")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('span', [_vm._v(_vm._s(item.max_stock - item.stock))])])]) : _c('div', {
      staticClass: "info-col"
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("目前存量")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('span', [_vm._v(_vm._s(item.stock))])])])])]) : _vm._e()
  }), (_vm.showRefillToNewDrugStorage) ? _c('RefillToNewDrugStorage', {
    on: {
      "refillNewDrugStorage": _vm.refillNewDrugStorage
    }
  }) : _vm._e()], 2) : _c('div', [_c('span', [_vm._v(" 無任何資料")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fee1b06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/DrugInDeviceList.vue
// module id = 1386
// module chunks = 1